"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgComponent(props, svgRef) {
  return (0, _jsxRuntime.jsx)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), {}, {
    children: (0, _jsxRuntime.jsxs)("g", {
      fillRule: "nonzero",
      fill: "none",
      children: [(0, _jsxRuntime.jsx)("path", {
        d: "M20.844 14.844c-.622 0-1.244-.4-1.466-1.022-.222-.578-.667-1.066-1.422-1.422a1.524 1.524 0 01-.756-2.044 1.524 1.524 0 012.044-.756c1.512.711 2.578 1.778 3.067 3.2.267.8-.133 1.689-.933 2-.178 0-.356.044-.534.044m5.423 0c-.756 0-1.378-.533-1.511-1.288-.623-3.423-2.978-5.778-6.49-6.49a1.53 1.53 0 01-1.2-1.822 1.53 1.53 0 011.823-1.2c4.8.934 8.133 4.312 8.933 8.978.134.845-.4 1.645-1.244 1.778-.09.044-.222.044-.311.044",
        fill: "#FF9E1A"
      }), (0, _jsxRuntime.jsx)("path", {
        d: "M14.933 22.622c-3.11 0-5.689-2.533-5.689-5.689 0-3.11 2.534-5.689 5.69-5.689.844 0 1.555.712 1.555 1.556 0 .844-.711 1.556-1.556 1.556a2.58 2.58 0 00-2.577 2.577 2.58 2.58 0 002.577 2.578 2.58 2.58 0 002.578-2.578c0-.844.711-1.555 1.556-1.555.844 0 1.555.71 1.555 1.555-.044 3.156-2.578 5.69-5.689 5.69",
        fill: "#1856ED"
      }), (0, _jsxRuntime.jsx)("path", {
        d: "M14.933 27.911C8.89 27.911 4 22.978 4 16.978A10.925 10.925 0 0114.933 6.044c.845 0 1.556.712 1.556 1.556 0 .844-.711 1.556-1.556 1.556-4.31 0-7.822 3.51-7.822 7.822 0 4.31 3.511 7.822 7.822 7.822s7.823-3.511 7.823-7.822c0-.845.71-1.556 1.555-1.556s1.556.711 1.556 1.556c0 6-4.934 10.933-10.934 10.933",
        fill: "#1856ED"
      })]
    })
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=ConstantContact.js.map